module.exports = __webpack_public_path__ + "static/img/bntb.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bntb.png
// module id = riGv
// module chunks = 42